module.exports = __webpack_public_path__ + "img/ALSH_SEJOUR_PRINTEMPS.e88cc22b.svg";